import {
  Avatar,
  IconButton,
  ListItem,
  ListItemAvatar,
  ListItemSecondaryAction,
  ListItemText,
  TextField,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import FolderIcon from "@material-ui/icons/Folder";
import { Key, useEffect, useState } from "react";
import { I18NTextField } from "../i18n_text_field";
import { AttachmentWithTitleItem } from "./attachments_list_with_title";

export interface AttachmentsListWithTitleItemProps {
  key: Key;
  item: AttachmentWithTitleItem;
  disabled?: boolean;
  onDeletingItem?: () => void;
  onChange?: (item: AttachmentWithTitleItem) => void;
}

export function AttachmentsListWithTitleItem(
  props: AttachmentsListWithTitleItemProps
) {
  const { item, disabled } = props;
  const { file } = item;
  const [name, setName] = useState(file.name);
  const [i18n, setI18n] = useState(item?.i18n || {});

  const triggerUpdate = () => {
    console.log("triggerUpdate()");
    if (!props.onChange) return;
    const newItem = { ...item };
    console.log(`newItem (clone) is ${JSON.stringify(newItem)}`);
    newItem.file = { ...file, name };
    newItem.i18n = { ...i18n };
    console.log(`newItem is ${JSON.stringify(newItem)}`);
    props.onChange(newItem);
  };

  useEffect(() => {
    triggerUpdate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n]);

  return (
    <ListItem key={props.key}>
      <ListItemAvatar>
        <Avatar>
          <IconButton onClick={() => window.open(file.url)}>
            <FolderIcon />
          </IconButton>
        </Avatar>
      </ListItemAvatar>
      <ListItemText
        primary={
          <TextField
            label={"Nome del file"}
            variant="outlined"
            type="text"
            style={{ width: "100%" }}
            value={name}
            onChange={(e) => setName(e.target.value)}
            onBlur={triggerUpdate}
          />
        }
      />
      <ListItemText
        primary={
          <I18NTextField
            label="Titolo dell'allegato"
            variant="outlined"
            i18nFieldName="title"
            onChange={setI18n}
            value={i18n}
            style={{ width: "100%", marginLeft: "5px" }}
          ></I18NTextField>
        }
      />
      <ListItemSecondaryAction>
        <IconButton
          disabled={disabled}
          onClick={props.onDeletingItem}
          edge="end"
          aria-label="delete"
        >
          <DeleteIcon />
        </IconButton>
      </ListItemSecondaryAction>
    </ListItem>
  );
}
